import React from 'react'
import styled from 'styled-components'
import LinearProgress from '@material-ui/core/LinearProgress'

export const StyledLinearProgress = styled(LinearProgress).attrs({
  variant: 'determinate',
})`
  margin: 24px;
` as React.ComponentType<any>
